// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---node-modules-gatsby-theme-auth-0-src-pages-auth-callback-tsx": () => import("./../../../node_modules/gatsby-theme-auth0/src/pages/auth/callback.tsx" /* webpackChunkName: "component---node-modules-gatsby-theme-auth-0-src-pages-auth-callback-tsx" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-authdebug-js": () => import("./../../../src/pages/authdebug.js" /* webpackChunkName: "component---src-pages-authdebug-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-plan-js": () => import("./../../../src/pages/plan.js" /* webpackChunkName: "component---src-pages-plan-js" */),
  "component---src-pages-pricing-js": () => import("./../../../src/pages/pricing.js" /* webpackChunkName: "component---src-pages-pricing-js" */)
}

